import { environment } from '../../../environments/environment';
import {PROMART_CODE, SUPERMERCADOS_CODE, igvNumber, PROMART_ECUADOR_CODE} from './company.config';
import { ConfigUser } from './user.config';
const getUserInfo = () => {
    return JSON.parse(localStorage.getItem(environment.sessionAuth));
  };

const getIGV = () => {
   const user = getUserInfo();
   return user && user.user.country ? igvNumber[user.user.country] : igvNumber.PE;
};

export const ConfigQuotation = {
    STATE_QUOTATION: {
        WORKING: 'WORKING',
        PAYMENT_PENDING: 'PAYMENT_PENDING',
        PAYMENT_ONLINE: 'PAYMENT_ONLINE',
        PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
        PAYED: 'PAYED',
        CANCELLED: 'CANCELLED',
        CANCELLED_NOT_PAYED: 'CANCELLED_NOT_PAYED',
        getProps: () => [
            { value: 'WORKING', text: 'En trabajo', recalculate: true, editable: true, printable: false, partialEdition: false },
            { value: 'PENDING_AUTHORIZATION', text: 'Pendiente autorización', recalculate: true, editable: false, printable: false, partialEdition: true },
            { value: 'PAYMENT_PENDING', text: 'Pago pendiente', recalculate: false, editable: false, printable: true, partialEdition: false },
            { value: 'PAYMENT_ONLINE', text: 'Pago online', recalculate: false, editable: false, printable: true, partialEdition: false },
            { value: 'PAYED', text: 'Pagada', recalculate: false, editable: false, printable: true, partialEdition: false },
            { value: 'CANCELLED', text: 'Cancelada', recalculate: false, editable: false, printable: false, partialEdition: false },
            { value: 'CANCELLED_NOT_PAYED', text: 'Cancelada no pagada', recalculate: false, editable: false, printable: false, partialEdition: false }
        ]
    },

    CUSTOMER_TYPES: {
        getProps: () => [
            { value: 'NATURAL_PERSON', text: 'PERSONA NATURAL' },
            { value: 'JURIDIC_PERSON', text: 'PERSONA JURÍDICA' },
            { value: 'MAYORIST', text: 'MAYORISTA' },
            { value: 'MINORIST', text: 'MINORISTA' }
        ]
    },
    SEARCH_TYPES_PRODUCTS: {
        SKU: 'SKU',
        EANCODE: 'EANCODE',
        DESCRIPTION: 'DESCRIPCION',
        getProps: () => [
            { value: 'sku', text: 'SKU' },
            { value: 'eanCode', text: 'EAN' },
            { value: 'DESCRIPTION', text: 'Descripción' }
        ]
    },
    IGV: getIGV(),
    MAX_STOCK_QUANTITY: 99999,
    PAYMENT_TYPES_ENTERPRISE: {
        CASH: 'CASH',
        OH_CARD: 'OH_CARD',
        COLLECTION_ACCOUNT: 'COLLECTION_ACCOUNT',
        DEFERRED_PAYMENT: 'DEFERRED_PAYMENT',
        CREDIT: 'CREDIT',
        CREDIT_CARD: 'CREDIT_CARD',
        OTHER: 'OTHER',
         AGORA: 'AGORA',
        WEB_PAYMENT: 'WEB_PAYMENT',
        AGORA_SHOP: 'AGORA_SHOP',
        CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
        DIRECT_CREDIT: 'DIRECT_CREDIT',
        getProps: () => [
            { value: 'CASH', viewValue: 'EFECTIVO/OTROS', state: true, cancellable: true, salecustomer: true, quotation: true, cashondelivery: false},
            { value: 'OH_CARD', viewValue: 'TARJETA OH!', state: true, cancellable: true, salecustomer: true, quotation: true, cashondelivery: false},
            { value: 'COLLECTION_ACCOUNT', viewValue: 'CUENTA RECAUDADORA', state: true, cancellable: false, salecustomer: false, quotation: true, cashondelivery: false},
            { value: 'DEFERRED_PAYMENT', viewValue: 'PAGO DIFERIDO', state: false, cancellable: true, salecustomer: false, quotation: false, cashondelivery: false},
            { value: 'CREDIT', viewValue: 'CRÉDITO', state: true, cancellable: true, salecustomer: false, quotation: true, cashondelivery: false},
            { value: 'CREDIT_CARD', viewValue: 'PAGO ELECTRÓNICO', state: true, cancellable: true, salecustomer: true, quotation: false, cashondelivery: false},
            { value: 'OTHER', viewValue: 'OTROS', state: true, cancellable: true, salecustomer: true, quotation: false, cashondelivery: false},
            { value: 'AGORA', viewValue: 'AGORA',  state: true, cancellable: true, salecustomer: true, quotation: true, paymentByCompany: [PROMART_CODE], cashondelivery: false},
            { value: 'WEB_PAYMENT', viewValue: 'PAGO WEB', state: true, cancellable: true, salecustomer: true, quotation: true, cashondelivery: false},
            { value: 'AGORA_SHOP', viewValue: 'AGORA SHOP', state: true, cancellable: true, salecustomer: true, quotation: true, cashondelivery: false},
            { value: 'CASH_ON_DELIVERY', viewValue: 'CONTRA ENTREGA', state: true, cancellable: false, salecustomer: false, quotation: false, cashondelivery: false},
            { value: 'DIRECT_CREDIT', viewValue: 'CRÉDITO DIRECTO', state: true, cancellable: true, salecustomer: false, quotation: true, paymentByCompany:[PROMART_ECUADOR_CODE], cashondelivery: false}
        ]
    },
    PERMISSIONS: ConfigUser.PERMISSIONS,
    TOGGLEACTION: {
        checkedChangeDiscount: false,
        checkedChangeMargin: false,
        checkedChangeIGV: false
    },
    DISPATCH_DEFAULT: 'NORMAL'
};

